import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware, { END } from 'redux-saga';
import { createBrowserHistory } from 'history';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import reducers from '../reducers';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistCombineReducers } from 'redux-persist';

const config = {
  key: 'root',
  storage,
  whitelist: ['app'],
  debug: true
};

const reducer = persistCombineReducers(config, {
  ...reducers,
  router: routerReducer
});

export default function configureStore(initialState) {
  const sagaMiddleware = createSagaMiddleware();
  const history = createBrowserHistory();
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    reducer,
    initialState,
    composeEnhancers(
      applyMiddleware(routerMiddleware(history), sagaMiddleware, createLogger())
    )
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers').default;
      store.replaceReducer(nextRootReducer);
    });
  }
  store.runSaga = sagaMiddleware.run;
  store.close = () => store.dispatch(END);
  store.history = history;

  // FIN-13485: persistStore() rehydrates immediately, so it is not created here. index.js calls
  // startPersisting() once the user's identity is known — the persisted Case Listing filters are
  // restored for their owner only, and that check needs the identity.
  const startPersisting = () => persistStore(store);
  return { startPersisting, store };
}
